import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("a97cd33fbf", "._3a6abd0125943bfa__container{height:100%;margin:0 auto;min-width:120px;width:100%}");
}
export default {"container":"_3a6abd0125943bfa__container"};
